export const shouldShowStagePillCountBadge = (count?: number): boolean =>
  count !== undefined && count > 1;
